import React, { PureComponent, Suspense } from 'react';
import { Layout } from 'antd';
import classNames from 'classnames';
import Link from 'umi/link';
import styles from './index.less';
import PageLoading from '../PageLoading';
import { getDefaultCollapsedSubMenus } from './SiderMenuUtils';
import { title } from '../../defaultSettings';
import { connect } from 'dva';

const BaseMenu = React.lazy(() => import('./BaseMenu'));
const { Sider } = Layout;

@connect(({ login, organisation }) => ({
  showCloudViewToAllOrgs: login.showCloudViewToAllOrgs,
  showCloudIQToAllOrgs: login.showCloudIQToAllOrgs,
  cloudViewEnabled: organisation?.current?.cloudViewEnabled,
  cloudIQEnabled: organisation?.current?.cloudIQEnabled,
}))
export default class SiderMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openKeys: getDefaultCollapsedSubMenus(props),
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { pathname, flatMenuKeysLen } = state;
    if (props.location.pathname !== pathname || props.flatMenuKeys.length !== flatMenuKeysLen) {
      return {
        pathname: props.location.pathname,
        flatMenuKeysLen: props.flatMenuKeys.length,
        openKeys: getDefaultCollapsedSubMenus(props),
      };
    }
    return null;
  }

  isMainMenu = key => {
    const { menuData } = this.props;
    return menuData.some(item => {
      if (key) {
        return item.key === key || item.path === key;
      }
      return false;
    });
  };

  handleOpenChange = openKeys => {
    const moreThanOne = openKeys.filter(openKey => this.isMainMenu(openKey)).length > 1;
    this.setState({
      openKeys: moreThanOne ? [openKeys.pop()] : [...openKeys],
    });
  };

  // CloudView is visible to all when the flag showCloudViewToAllOrgs is set to true otherwise it is visible only to the orgs where cloudViewEnabled is set to true
  isCloudViewVisible = () => {
    const { showCloudViewToAllOrgs, cloudViewEnabled } = this.props;
    if (showCloudViewToAllOrgs) {
      return true;
    } else {
      return cloudViewEnabled ? cloudViewEnabled : false;
    }
  };
  // CloudIQ is visible to all when the flag showCloudIQToAllOrgs is set to true otherwise it is visible only to the orgs where cloudIQEnabled is set to true
  isCloudIQVisible = () => {
    const { showCloudIQToAllOrgs, cloudIQEnabled } = this.props;
    if (showCloudIQToAllOrgs) {
      return true;
    } else {
      return cloudIQEnabled ? cloudIQEnabled : false;
    }
  };
  render() {
    const { logo, collapsed, onCollapse, fixSiderbar, theme, isMobile, flatMenuKeys } = this.props;
    const { openKeys } = this.state;
    const defaultProps = collapsed ? {} : { openKeys };
    const siderClassName = classNames(styles.sider, {
      [styles.fixSiderBar]: fixSiderbar,
      [styles.light]: theme === 'light',
      [styles.isMobile]: isMobile === true,
    });

    if (this.props) {
      // Find index of Monitoring in the menuData array
      const indexOfMonitoring = this.props.menuData.findIndex(each => each.name === 'Monitoring');

      // Conditionally modify the children of the Monitoring menu item
      this.props.menuData[indexOfMonitoring].children = this.isCloudViewVisible()
        ? this.props.menuData[indexOfMonitoring].children
        : this.props.menuData[indexOfMonitoring].children.filter(
            each => each.name !== 'Cloud View'
          );

      // Find index of CloudIQ in the menuData array
      const indexOfCloudIQ = this.props.menuData.findIndex(each => each.name === 'CloudIQ');

      // Conditionally remove the CloudIQ menu item if not visible
      if (!this.isCloudIQVisible() && indexOfCloudIQ !== -1) {
        this.props.menuData.splice(indexOfCloudIQ, 1);
      }

      // Update the props with the modified menuData
      this.props = {
        ...this.props,
        menuData: [...this.props.menuData],
      };
    }

    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        width={230}
        theme={theme}
        className={siderClassName}
      >
        <Suspense fallback={<PageLoading />}>
          <BaseMenu
            {...this.props}
            mode="inline"
            handleOpenChange={this.handleOpenChange}
            onOpenChange={this.handleOpenChange}
            style={{ padding: '18px 0', width: '100%' }}
            {...defaultProps}
          />
        </Suspense>
      </Sider>
    );
  }
}
